export default {
      id: "vk-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#vk-usage",
      toString: function () {
        return this.url;
      }
    }